@if (!loading()) {
  <div class="content f-c b-bg">
    <mn-header />
    <div class="main">
      <mn-game-panel />
      <mn-bet-panel />
    </div>
    @if (acS.mS$()) {
      <mn-menu (outsideClick)="acS.mS$.set(null)" />
    }
  </div>
} @else {
  <mn-splash-screen />
}
